<app-centered-card-layout title="Login" subtitle="Hello! Please log in with your email."
                          backgroundImgSrcUrl="https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?q=80&w=2388&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D">
  <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()" card-content>
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput
             type="email"
             placeholder="Email address"
             formControlName="email"
             required
             autocomplete="email"
      />
      <mat-error *ngIf="loginForm.get('email')!.hasError('required')">Email is required</mat-error>
      <mat-error *ngIf="loginForm.get('email')!.hasError('pattern')">Email is not valid</mat-error>
    </mat-form-field>

    <mat-form-field class="full-width pt-16" appearance="outline">
      <mat-label>Password</mat-label>
      <input matInput
             [type]="hidePassword ? 'password' : 'text'"
             placeholder="Password"
             formControlName="password"
             required
             autocomplete="current-password"/>
      <mat-icon matSuffix (click)="hidePassword = !hidePassword">
        {{ hidePassword ? 'visibility_off' : 'visibility' }}
      </mat-icon>
      <mat-error *ngIf="loginForm.get('password')!.hasError('required')">Password is required</mat-error>
    </mat-form-field>

    <mat-error *ngIf="loginForm.get('password')!.hasError('login-failed')">Username or password is incorrect
    </mat-error>

    <button mat-raised-button color="primary"
            type="submit"
            class="full-width main-login-button" style="margin-top: 16px"
            [disabled]="loading || (loader.loading$ | async)">
      {{ loading || (loader.loading$ | async) ? buttonText : 'Login' }}
    </button>
    @if (loading || (loader.loading$ | async)) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </form>
  <div card-actions>
    <button mat-button (click)="userForgotPassword()">Forgot your password?</button>
  </div>
</app-centered-card-layout>
